import React, { useEffect, useState } from 'react'
import styles from './CustomerCardAndChat.module.scss'
import CustomerCard from './CustomerCard/CustomerCard'
import Chat from './Chat/Chat'
import { superAxiosRequest } from 'axiosApi'
import { useLocation, useParams } from 'react-router-dom'
import Loader from 'components/ContentBox/Global/Loader/Loader'

const CustomerCardAndChat = () => {
  const [isClose, setIsClose] = useState({ card: false, chat: false })
  const [dealData, setDealData] = useState({})
  const [dealStatuses, setDealStatuses] = useState([])
  const [loading, setLoading] = useState(false)
  const [selectedStatus, setSelectedStatus] = useState(2) // 2 - начальный статус сделки (New Request)
  const { id: dealId } = useParams()

  const location = useLocation()
  const searchParams = new URLSearchParams(location.search)
  const funnelId = searchParams.get('funnel_id')

  const fetchDealData = () => {
    setLoading(true)
    const apiConf = {
      method: 'get',
      link: `integration/deals/${dealId}`,
      crm: true,
    }

    superAxiosRequest(apiConf)
      .then((res) => {
        const selectedStatus = res?.data?.funnels.find(
          (f) => f.id === +funnelId,
        )?.status_deal_id

        setDealData(res.data)
        setSelectedStatus(selectedStatus)
      })
      .catch((err) => {
        console.log(err)
      })
      .finally(() => {
        setLoading(false)
      })
  }

  useEffect(() => {
    fetchDealData()
  }, [])

  useEffect(() => {
    const apiConf = {
      method: 'get',
      link: `integration/deal_statuses`,
      crm: true,
      params: {
        funnel_id: funnelId,
      },
    }

    superAxiosRequest(apiConf)
      .then((res) => {
        setDealStatuses(res.data)
      })
      .catch((err) => {
        console.log(err)
      })
  }, [])

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <div className={styles.container}>
          <CustomerCard
            isClose={isClose}
            setIsClose={setIsClose}
            dealData={dealData}
            dealStatuses={dealStatuses}
            selectedStatus={selectedStatus}
            setSelectedStatus={setSelectedStatus}
            dealId={dealId}
            fetchDealData={fetchDealData}
          />
          <Chat
            fetchDealData={fetchDealData}
            dealId={dealId}
            dealData={dealData}
            setDealData={setDealData}
            isClose={isClose}
            setIsClose={setIsClose}
            funnelId={funnelId}
          />
        </div>
      )}
    </>
  )
}

export default CustomerCardAndChat
